import React, { useEffect, useState } from "react"
import {
  change,
  Field,
  formValueSelector,
  isDirty,
  resetSection,
} from "redux-form"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { RadioField, SingleSelectField } from "components/RenderInput"
import "components/style.scss"
import ColorPicker from "components/ColorPicker"
import { connect } from "react-redux"
import { FORM_NAMES } from "constants/index"
import ImageEditor from "components/ImageEditor"
import { FONTS } from "constants/fonts"
import UnsavedAlertModal from "components/UnsavedAlertModal"

const DesignTab = ({
  bgImageType,
  change,
  thumbnailImageType,
  tabIsActive,
  isDirty,
  resetForm,
  handleSave,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>Design</h4>
        </CardHeader>
        <CardBody>
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Menu color:
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <Field name="menuColor" component={ColorPicker} />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Background color:
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <Field name="bgColor" component={ColorPicker} />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Background image:
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <div className="mb-3">
                <Field
                  name="bgImageType"
                  type="radio"
                  component={RadioField}
                  value="1"
                  label="Default Background"
                />
              </div>
              <div>
                <Field
                  name="bgImageType"
                  type="radio"
                  component={RadioField}
                  value="2"
                  label="Add your own Background"
                />
              </div>
            </Col>
          </Row>
          {bgImageType === "2" && (
            <Row className="my-3 justify-content-end">
              <Col xs={12} md={8} sm={6} lg={8}>
                <Field
                  name="bgImage"
                  component={ImageEditor}
                  onDelete={() => change("setup.deleteBgImage", true)}
                />
              </Col>
            </Row>
          )}
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Thumbnail image:
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <div className="mb-3">
                <Field
                  name="thumbnailImageType"
                  type="radio"
                  component={RadioField}
                  value="1"
                  label="Default Thumbnail image"
                />
              </div>
              <div>
                <Field
                  name="thumbnailImageType"
                  type="radio"
                  component={RadioField}
                  value="2"
                  label="Add your own Thumbnail image"
                />
              </div>
            </Col>
          </Row>
          {thumbnailImageType === "2" && (
            <Row className="my-3 justify-content-end">
              <Col xs={12} md={8} sm={6} lg={8}>
                <Field
                  name="thumbnailImage"
                  component={ImageEditor}
                  onDelete={() => change("setup.deleteThumbnailImage", true)}
                />
              </Col>
            </Row>
          )}
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Text color:
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <Field name="textColor" component={ColorPicker} />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={4} sm={6} lg={4}>
              Font:
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <Field
                className="full-width"
                name="font"
                fullWidth={true}
                component={SingleSelectField}
                options={FONTS.map(font => ({
                  value: font.value,
                  label: font.text,
                }))}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4} sm={6} lg={4}>
              Background animation:
            </Col>
            <Col xs={12} md={8} sm={6} lg={8}>
              <div className="mb-2">
                <Field
                  name="bgAnimation"
                  type="radio"
                  component={RadioField}
                  value="0"
                  label={
                    <>
                      No Animation- The background selected above will be
                      displayed.
                    </>
                  }
                />
              </div>
              <div className="mb-2">
                <Field
                  name="bgAnimation"
                  type="radio"
                  component={RadioField}
                  value="flip"
                  label={
                    <>
                      Flip Background- The background image will change every
                      time someone adds pictures to the media gallery
                      <br />
                      <b>NOTE:</b> The background selected above will be
                      displayed until media has been uploaded to the media
                      gallery.
                    </>
                  }
                />
              </div>
              <div className="mb-2">
                <Field
                  name="bgAnimation"
                  type="radio"
                  component={RadioField}
                  value="scroll"
                  label={
                    <>
                      Scroll Through Media Gallery- The background will cycle
                      through all the photos in the media gallery automatically.
                      <br />
                      <b>NOTE:</b> The background selected above will be
                      displayed until media has been uploaded to the media
                      gallery.
                    </>
                  }
                />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.EXPERIENCE)

const mapStateToProps = state => ({
  bgImageType: selector(state, "setup.bgImageType"),
  thumbnailImageType: selector(state, "setup.thumbnailImageType"),
  isDirty: isDirty(FORM_NAMES.EXPERIENCE)(
    state,
    ...[
      "setup.menuColor",
      "setup.bgColor",
      "setup.bgImageType",
      "setup.thumbnailImageType",
      "setup.textColor",
      "setup.font",
      "setup.bgAnimation",
      "setup.bgImage",
      "setup.thumbnailImage",
    ]
  ),
})

const mapDispatchToProps = dispatch => ({
  change: (name, value) =>
    dispatch(change(FORM_NAMES.EXPERIENCE, `${name}`, value)),
  resetForm: () => dispatch(resetSection(FORM_NAMES.EXPERIENCE, ...["setup"])),
})

export default connect(mapStateToProps, mapDispatchToProps)(DesignTab)
